export default "__VITE_ASSET__BXhFhhN1__"